module.exports = __webpack_public_path__ + "static/media/FFMountainAZBattleDMGEXTA0030_design_clean_v001.eba280f2.webp";